import { useSelector } from 'react-redux'
import useValidator from 'utils/hooks/useValidator'
import { isPresent, siteNameRegex, whitespaceOnlyRegex } from 'utils'
import { useCallback } from 'react'
import { BizChannelTypes } from '../../../Codes'
import { hasURL } from '../part/SiteURL'

export default () => {
  const {
    bizChannelType,
    name,
    isUrlIndividual,
    unifiedUrl,
    pcUrl,
    mobileUrl,
    isUnifiedUrlChecked,
    isPcUrlChecked,
    isMobileUrlChecked,
    hasAccessAccount,
    accessAccountId,
    accessAccountPassword,
    selectedCategory,
    selectedCategoryDetail,
    kakaoTalkChannels,
  } = useSelector(state => state.channel.channelAdd)

  const { errors, validate, addError, clearError } = useValidator(
    oldErrors => ({
      ...oldErrors,
      name:
        (!isPresent(name) && '비즈채널명을 입력해주세요.') ||
        (!siteNameRegex.test(name) &&
          '입력 불가능한 문자가 입력되어 있습니다.') ||
        (whitespaceOnlyRegex.test(name) && '비즈채널명이 올바르지 않습니다.'),
      selectedCategory:
        !isPresent(selectedCategory?.name) && '비즈채널 업종을 선택해주세요.',
      selectedCategoryDetail:
        isPresent(selectedCategory?.name) &&
        !isPresent(selectedCategoryDetail?.name) &&
        '비즈채널 업종을 선택해주세요.',
      accessAccountId:
        hasAccessAccount &&
        !isPresent(accessAccountId) &&
        '아이디, 비밀번호를 입력해주세요.',
      accessAccountPassword:
        hasAccessAccount &&
        !isPresent(accessAccountPassword) &&
        '아이디, 비밀번호를 입력해주세요.',
      mobileUrl:
        isUrlIndividual &&
        !hasURL(mobileUrl) &&
        !hasURL(pcUrl) &&
        '모바일 URL을 입력해주세요.',
      pcUrl:
        bizChannelType === BizChannelTypes.WEBSITE_BIZ_CHANNEL &&
        isUrlIndividual &&
        !hasURL(mobileUrl) &&
        !hasURL(pcUrl) &&
        'PC URL을 입력해주세요.',
      unifiedUrl:
        !isUrlIndividual &&
        !hasURL(unifiedUrl) &&
        '웹사이트 URL을 입력해주세요.',
      unifiedUrlConnection:
        !isUrlIndividual &&
        !isUnifiedUrlChecked &&
        '웹사이트 연결 확인이 필요합니다.',
      mobileUrlConnection:
        isUrlIndividual &&
        hasURL(mobileUrl) &&
        !isMobileUrlChecked &&
        '모바일 웹사이트 연결 확인이 필요합니다.',
      pcUrlConnection:
        bizChannelType === BizChannelTypes.WEBSITE_BIZ_CHANNEL &&
        isUrlIndividual &&
        hasURL(pcUrl) &&
        !isPcUrlChecked &&
        'PC 웹사이트 연결 확인이 필요합니다.',
      kakaoTalkChannel:
        bizChannelType === BizChannelTypes.TALK_CHANNEL &&
        kakaoTalkChannels.every(({ isSelected }) => isSelected === false) &&
        '카카오톡 채널을 선택해주세요.',
    }),
    [
      bizChannelType,
      name,
      isUrlIndividual,
      unifiedUrl,
      pcUrl,
      mobileUrl,
      isUnifiedUrlChecked,
      isPcUrlChecked,
      isMobileUrlChecked,
      hasAccessAccount,
      accessAccountId,
      accessAccountPassword,
      selectedCategory,
      selectedCategoryDetail,
      kakaoTalkChannels,
    ]
  )

  const addUnifiedUrlError = useCallback(
    e => {
      addError({ unifiedUrlFormat: e && '올바른 URL 형식이 아닙니다' })
    },
    [addError]
  )

  const addMobileUrlError = useCallback(
    e => {
      addError({ mobileUrlFormat: e && '올바른 URL 형식이 아닙니다' })
    },
    [addError]
  )

  const addPcUrlError = useCallback(
    e => {
      addError({ pcUrlFormat: e && '올바른 URL 형식이 아닙니다' })
    },
    [addError]
  )

  return {
    errors,
    validate,
    addError,
    addUnifiedUrlError,
    addMobileUrlError,
    addPcUrlError,
    clearError,
  }
}
